import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { DateAdapter, ErrorStateMatcher } from '@angular/material/core';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/contract/shared/user-management.service';
import { Organisation } from 'src/app/shared/organisation.model';
import { Plan } from 'src/app/shared/plan.model';
import { UserService } from 'src/app/shared/user.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Component({
  selector: 'app-organisation-form',
  templateUrl: './organisation-form.component.html',
  styleUrls: ['./organisation-form.component.scss']
})
export class OrganisationFormComponent implements OnInit {
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('fileInput') fileInput: ElementRef;
  logoPreview: string | ArrayBuffer;
  selectedFileName: string;
  id: string;
  mode: string;
  fileToUpload: File = null;
  selectedImage: string | ArrayBuffer | null = null;
  userForm: any = FormGroup;
  contactForm: any = FormGroup;
  planForm: any = FormGroup
  matcher = new MyErrorStateMatcher();
  isLoading: boolean = false;
  orgData: Organisation;
  planData: Plan;
  formLoading: boolean = false;
  base64Image = null;
  countries = [
    {
      id: 1,
      name: 'INDIA'
    }, {
      id: 2,
      name: 'UNITED KINGDOM'
    }, {
      id: 3,
      name: 'UNITED STATES'
    }, {
      id: 4,
      name: 'GERMANY'
    }, {
      id: 5,
      name: 'FRANCE'
    },
  ];

  constructor(public usermanagementService: UserManagementService, public userService: UserService, private router: Router, private route: ActivatedRoute, private formBuilder: FormBuilder, private toast: ToastrService, private dateAdapter: DateAdapter<Date>) {
    this.dateAdapter.setLocale('en-GB');

    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.mode = params['mode'];
    });

    if (this.mode)
      this.formLoading = true;

    this.userForm = this.formBuilder.group({
      organizationName: ['', [Validators.required]],
      addressLine1: [''],
      addressLine2: [''],
      registrationNumber: ['', [Validators.required]],
      zipCode: ['', [Validators.required]],
      countryId: [null, [Validators.required]],
      status: [0],
      id: [0],
      // orgLogo:['dfg'],
      noOfEmployees: [null, [Validators.required]],
      noOfLicensesReq: [null],
      orgWebsite: ['', [Validators.pattern('^(?:(?:https?://)?(?:www\.)?)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?$')]],
      planId: [1]

    });

    this.contactForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      officialEMail: ['', [Validators.required, Validators.email]],
      contactNumber: ['', [Validators.required]],
    });

    // this.planForm = this.formBuilder.group({
    //   name: ['', [Validators.required]],
    //   cost: ['', [Validators.required]],
    //   startDate: ['', [Validators.required]],
    //   endDate: ['', [Validators.required]],
    //   maxContractTypes: ['', [Validators.required]],
    //   maxContracts: ['', Validators.required],
    //   maxUsers: ['', Validators.required],
    //   activeUser: ['', [Validators.required]],
    //   allowTran: ['', [Validators.required]],
    //   totalTran: ['', [Validators.required]]
    // })

    if (this.mode == 'view') {
      this.userForm.disable();
      this.contactForm.disable();
    }
  }

  async ngOnInit(): Promise<void> {
    if (this.id) {

      await this.usermanagementService.getTenetById(this.id).then((res: Organisation) => {
        this.orgData = res;

        this.userForm.patchValue(this.orgData);
        this.contactForm.patchValue(this.orgData);
        // Use logoUrl if available, otherwise fall back to orgLogo
        if (this.orgData?.logoUrl) {
          this.base64Image = this.orgData.logoUrl;
        } else if (this.orgData?.orgLogo) {
          // Check if orgLogo is already a URL or a base64 string
          if (this.orgData.orgLogo.startsWith('http://') || this.orgData.orgLogo.startsWith('https://')) {
            this.base64Image = this.orgData.orgLogo;
          } else {
            this.base64Image = `data:image/png;base64,${this.orgData.orgLogo}`;
          }
        }

      });
  
      // await this.usermanagementService.getPlanById(this.id).then((res: Plan) => {
      //   this.planData = res;
      //   this.planForm.patchValue(this.planData)
      // });

      this.selectedImage = null;
      this.formLoading = false
    }
  }

  async onFileSelected(event) {
    this.isLoading = true;
    const file: File = event.target.files[0];
    if (file) {
      if (this.id) {
        try {
          await this.usermanagementService.updateOrgImage(file, this.orgData.id).then((res: any) => {
            // API returns URL in body field, use it directly
            if (res && res.body) {
              this.base64Image = res.body;
              // Update orgData with the new logoUrl
              if (this.orgData) {
                this.orgData.logoUrl = res.body;
              }
            }
            this.toast.success('The image has been updated successfully!', '');
          })
          if (this.userService.loggedInOrg?.id == this.orgData?.id) {
            this.usermanagementService.getTenetById(this.orgData?.id.toString()).then((res: Organisation) => {
              this.userService.loggedInOrg = res;
            })
          }
        } catch {
          this.toast.error('Failed to upload the image!', '');
        }
      } else {
        this.fileToUpload = file;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.selectedImage = reader.result;
        };
      }
    }
    this.isLoading = false;
  }


  reset() {
    this.userForm.reset();
    this.contactForm.reset();
    // this.planForm.reset();
    if (this.stepper) {
      this.stepper.reset();
    }
  }


  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  async addOrg(activate = false) {
    if (!this.id) {
      if (this.userForm.valid && this.contactForm.valid) {
        this.isLoading = true;
        if (activate)
          this.userForm.get('status').setValue(1);
        const orgData = { ...this.userForm.value, ...this.contactForm.value }
        // orgData.id = parseInt(this.id);
        delete orgData.id;
        try {
          await this.usermanagementService.addOrg(orgData, this.fileToUpload).then((res: any) => {
            this.reset();
            this.isLoading = false;
            this.toast.success('The Organisation has been created succesfully.', '');
            this.router.navigate(["/app/organisation/list"]);
          })
        } catch {
          this.toast.error('Failed to create the organisation!', '');
          this.isLoading = false;
        }

      }
    }
    // else {
    //   console.log(this.contactForm,this.userForm);
    //   if (this.userForm.valid && this.contactForm.valid) {
    //     this.isLoading = true;
    //     const orgData = { ...this.userForm.value, ...this.contactForm.value }
    //     this.usermanagementService.addOrg(orgData).then((res: any) => {
    //     })
    //   }
    // }
  }
  // onLogoSelected(event: any): void {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       this.logoPreview = reader.result;
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // }

}
